import i18n from '@/i18n/i18n'
import store from '@/store'
import { OPEN_DIALOG } from '@/store/actions'
import { logError } from './errorLogger'
import { isJson } from './helpers'
import { TError } from './types/commonTypes'

const SYSTEM_ERROR_KEY = 'errors.6000'

const systemErrorCodes = ['3145', '3142', '3118', '3002']

function translateErrorCode(code: string | string[], fieldTemplate?: Record<string, string>): string {
  const t = i18n.global.t
  if (systemErrorCodes.includes(code as string)) {
    return t(SYSTEM_ERROR_KEY)
  }

  const key = `errors.${code}`
  return i18n.global.te(key) ? t(key, { ...fieldTemplate }) : t(SYSTEM_ERROR_KEY)
}

export function processError(error: TError, fieldTemplate?: Record<string, string>) {
  const t = i18n.global.t
  let isCustomValidation = false
  let errorDetails
  if (typeof error === 'string') {
    if (isJson(error)) {
      const jsonObject = JSON.parse(error)
      if (jsonObject?.MessageResult) {
        isCustomValidation = true
        errorDetails = jsonObject.MessageResult
      } else {
        errorDetails = translateErrorCode(error, fieldTemplate)
        logError(error, { ...fieldTemplate }, error, errorDetails)
      }
    } else {
      errorDetails = translateErrorCode(error, fieldTemplate)
      logError(error, { ...fieldTemplate }, error, errorDetails)
    }
  } else if (error.message) {
    errorDetails = translateErrorCode(error.message, fieldTemplate)
    logError(errorDetails, { ...fieldTemplate }, error.message.toString(), errorDetails)
  } else {
    errorDetails = Object.entries(error)
      .map(([field, value]) =>
        value
          .map((errorCode: string) => {
            const msg = `[ERR.${errorCode}] ` + translateErrorCode(errorCode, { field })
            return errorCode === '3148' ? `${msg}。${t('press_back_button')}` : msg
          })
          .join('<br />')
      )
      .join('<br />')
  }

  return {
    errorDetails: isCustomValidation ? errorDetails : t('error template', { errors: errorDetails }),
  }
}

export function parseErrorLines(error: TError, fieldTemplate?: Record<string, string>): string[] {
  const { errorDetails } = processError(error, fieldTemplate)
  return String(errorDetails)
    .split(/<br\s*\/?>/)
    .map((s) => s.replace(/<[^>]+>/g, '').trim())
    .filter(Boolean)
}

export default function errorHandler(error: TError, fieldTemplate?: Record<string, string>) {
  const { errorDetails } = processError(error, fieldTemplate)

  store.dispatch(OPEN_DIALOG, {
    title: i18n.global.t('el.messagebox.error'),
    message: errorDetails,
  })
}
